import(/* webpackMode: "eager" */ "/app/src/app/(frontend)/prop-firm/page.tsx");
